const redirectToMain = () => window.open('/signin', '_self');

export default redirectToMain;
